import {CoreModel} from '../../model/CoreModel';
import {CoreController} from '../../controller/CoreController';
import {DefineInitialSoundState} from './DefineInitialSoundState';
import {ChangeOrders} from '../../events/ChangeOrders';
import {CoreBodyMediator} from '../../mediators/CoreBodyMediator';
import {CoreSwiperMediator} from '../../mediators/CoreSwiperMediator';
import {CoverDisplayMediator} from '../../../components/mediators/CoverDisplayMediator';
import {HelperDisplayMediator} from '../../../components/mediators/HelperDisplayMediator';
import {Tunnel3DMediator} from '../../../components/mediators/Tunnel3DMediator';
import {EventDisplayMediator} from '../../../components/mediators/EventDisplayMediator';
import {StoryDisplayMediator} from '../../../components/mediators/StoryDisplayMediator';
import {MenuMediator} from '../../../components/mediators/MenuMediator';
import {ButtonMediator} from '../../../components/mediators/ButtonMediator';
import {SandwichMediator} from '../../../components/mediators/SandwichMediator';
import {SoundControlMediator} from '../../../components/mediators/SoundControlMediator';
import {SoundChannelsMediator} from '../../../components/mediators/SoundChannelsMediator';
import {KeyboardMediator} from '../../../components/mediators/KeyboardMediator';

const InitApp = app => {
    return new Promise(resolve => {
        if (!app) {
            resolve(app);
            return;
        }

        // Init Model and initial state
        const model = CoreModel.instance();

        // Components

        // Mediators
        const mdrsLvl1 = [];
        mdrsLvl1.push(CoreBodyMediator(document.body, model));
        mdrsLvl1.push(CoreSwiperMediator(document.querySelector('.swiper-container'), model));

        //
        let mdrsLvl2 = [];
        mdrsLvl2.push(CoverDisplayMediator(document.querySelector('.cover'), model));
        mdrsLvl2.push(HelperDisplayMediator(document.querySelector('.helper'), model));
        mdrsLvl2.push(Tunnel3DMediator(document.querySelector('.illustration--stage3d'), model));
        mdrsLvl2.push(MenuMediator(document.querySelector('.menu'), model, [document.querySelector('.app'), document.querySelector('.header')]));
        mdrsLvl2.push(SandwichMediator(document.querySelector('.ui-sandwich'), model));
        mdrsLvl2.push(SoundControlMediator(document.querySelector('.sound-control'), model));
        mdrsLvl2.push(SoundChannelsMediator(model));
        mdrsLvl2.push(KeyboardMediator(window, model));

        const eventElements = [...document.querySelectorAll('.event')];
        const stage3dCanvas = document.querySelector('.app__illustrations__area');

        // Events' mediators:
        mdrsLvl2 = mdrsLvl2.concat(eventElements.map(el => EventDisplayMediator(el, stage3dCanvas, model, [document.querySelector('.app')])));

        // Story animations' mediators:
        mdrsLvl2 = mdrsLvl2.concat(eventElements.map(el => StoryDisplayMediator(el, model)));

        // Menu navigation buttons mediators:
        mdrsLvl2 = mdrsLvl2.concat([...document.querySelectorAll('.ui-nav')].map(el => ButtonMediator(el, ChangeOrders.NAV_TO_STATE, el.dataset.toSectionId)));

        //
        mdrsLvl2.push(ButtonMediator(document.querySelector('.ui-close-helper'), ChangeOrders.CLOSE_HELPER));

        // Controller
        const controller = CoreController(app, mdrsLvl1, mdrsLvl2);

        app.model = model;
        app.controller = controller;

        DefineInitialSoundState(true);

        controller.init();

        resolve(app);
    });
};

export {InitApp};
